import React from 'react';
import ReactDOM from 'react-dom/client';
import { findDivsByIds, getKeywordsFromDiv } from './utils/domUtils';
import OfferComponent from './offers';
import PcOfferComponent from './pcOffers';
import './index.less';

function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // 使用正则表达式检测常见移动设备关键字
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

  return mobileRegex.test(userAgent);
}

function checkBodySpmContainsPc() {
  const body = document.body;
  const spmValue = body.getAttribute('data-spm');

  if (!spmValue) {
    console.log('body 上没有 data-spm 属性');
    return false;
  }

  const containsPc = spmValue.includes('pc');
  console.log(`data-spm 值: ${spmValue}`);
  console.log(`是否包含 "pc": ${containsPc}`);

  return containsPc;
}

const initializeOffers = () => {
  // 获取所有目标 div
  // const targetIds = ['p_0', 'p_1', 'p_2'];
  // const targetDivs = findDivsByIds(targetIds);
  // const targetDivs = document.querySelectorAll('div[id^="p_"],div.article-offers-block:is([data-keywords],[keywords])');
  const targetDivs = document.querySelectorAll('div[id^="p_"],div.article-offers-block[data-keywords],div.article-offers-block[keywords]');

  console.log('targetDivs', targetDivs);

  // 为每个 div 创建并挂载 offer 组件
  targetDivs.forEach((div) => {

    if (div) {
      const keywords = getKeywordsFromDiv(div);

      const root = ReactDOM.createRoot(div);
      root.render(
        <div className='article-offers-wrapper'>
          {
            checkBodySpmContainsPc() ?
              <PcOfferComponent keywords={keywords} />
              :
              <OfferComponent keywords={keywords} />
          }

        </div>
      );
    }
  });
};

initializeOffers();

// 导出初始化函数
export default initializeOffers;
